// API Format
// https://api.openweathermap.org/data/2.5/weather?id={#ID}&units=metric&appid=b4d946ff4f6671c8186ad54a3f7457e5
// Docs: https://openweathermap.org/current
/* eslint-disable */
const stanford    = 5398563;
const harvard     = 4931972;
const copenhagen  = 2621941;
const API_KEY     = 'b4d946ff4f6671c8186ad54a3f7457e5';
const ONE_HOUR = 60 * 60 * 1000;

let weatherObj  = {},
    weatherJSON = {},
    date = $('.weather').data('time');


function changeTimezone(date, ianatz) {

  // suppose the date is 12:00 UTC
  var invdate = new Date(date.toLocaleString('en-US', {
    timeZone: ianatz
  }));

  // then invdate will be 07:00 in Toronto
  // and the diff is 5 hours
  var diff = date.getTime() - invdate.getTime();

  // so 12:00 in Toronto is 17:00 UTC
  return new Date(date.getTime() - diff); // needs to substract

}

function checkNeedsUpdate(date) {
  let needsUpdate = false,
      nowDate = changeTimezone(new Date(), 'America/Los_Angeles');

  if( nowDate.getTime() - (new Date(date).getTime()) > ONE_HOUR) {
    needsUpdate = true;
    // console.log('updated');
  }

  return needsUpdate;
}

function getWeatherAPI(location) {
  const weather = fetch('https://api.openweathermap.org/data/2.5/weather?id='+location+'&units=metric&appid='+API_KEY)
    .then((response) => {
      if(response.ok) {
          return response.json();
      } else {
          throw new Error('Server response wasn\'t OK');
      }
    })
    .then((temp) => {
      return temp.main.temp;
  });

  return weather;
}

function updateWeatherBar(key) {
  if(weatherObj[key]) {
    let thisWrap = $('#weather-'+key).find('.temp');
    weatherObj[key].then((value => {
      thisWrap.html(value);
      weatherJSON[key] = value;
    }));
  }
}

function updateWeatherDatabase() {
  weatherJSON.time = changeTimezone(new Date(), 'America/Los_Angeles');

  jQuery.ajax({
     type : 'post',
     dataType : 'json',
     url : myAjax.ajaxurl,
     data : {
        action: 'store_weather',
        weather: weatherJSON
     }
  });

}

let weather = function() {

  $('.weather').removeAttr('data-time');

  if(checkNeedsUpdate(date)) {

    weatherObj.stanford    = getWeatherAPI(stanford);
    weatherObj.harvard     = getWeatherAPI(harvard);
    weatherObj.copenhagen  = getWeatherAPI(copenhagen);


    Object.keys(weatherObj).forEach(function eachKey(key) {
      // Check if response is a promise
      updateWeatherBar(key);
    });

    // REDO this as a promise from the above
    //
    setTimeout(function(){
      updateWeatherDatabase();
    }, 1000);

  }

  // Check individual temps
  $('.weather-wrap').each(function(){
    let fetch = $(this).data('fetch');
    if(fetch) {
      weatherObj.stanford = getWeatherAPI(eval( $(this).data('location')))
      Object.keys(weatherObj).forEach(function eachKey(key) {
        updateWeatherBar(key);
      });

      updateWeatherDatabase();

    }
  })

}

export default weather();



// WEBPACK FOOTER //
// ./scripts/functions/weather.js